module.exports = __webpack_public_path__ + "img/health32_7-9-2021.ae7ba2bd.jpg";